import { TextField } from "@mui/material";
import ErrorMessageHandle from "../Error/ErrorMessageHandle";

const HiddenTextBox = ({ name, value, error, required, validate, register }: any) => {
  return (
    <>
      <TextField
        type='hidden'
        variant='filled'
        name={name}
        id={name}
        sx={{
          ".Mui-error.Platform-x-FilledInput-root": { border: "none" },
          display: "none",
        }}
        error={error}
        value={value}
        {...register(name, {
          // Always pass required/validate explicitly (even falsy) — react-hook-form
          // merges register() options into the field's existing config rather than
          // replacing it, so omitting a previously-set rule here would not clear it.
          required,
          validate,
        })}
      />
      <ErrorMessageHandle error={error} />
    </>
  );
};

export default HiddenTextBox;
